import React from 'react';
import { Button, Drawer, Input, message } from 'antd';

import debounce from 'debounce';

import { _postCheckIfEmailExist, _postRegisterGhostUser } from '../../../services';

class AddGhostUserDrawer extends React.Component{

	render(){
		
		
		
		return (
			<Drawer
				width={640}
				placement="right"
				closable={true}
				maskClosable={false}
				onClose={this.props.onClose}
				visible={this.props.visible}
			>

				<h2>Add Ghost User</h2>

				<Input 
					placeholder={"Email"}
					onChange={ this.onChangeEmail }
					value={this.state.email} />

				<Button 
					style={{ marginTop:16 }}
					onClick={ this.doRegisterUser }
					type="primary" 
					disabled={!this.state.valid} >
					Register User
				</Button>
				
			</Drawer>
		);
	}

	constructor( props ){
		super(props);

		this.state = {
			email: props.defaultEmail || "",
			valid: false
		};

		// eslint-disable-next-line no-useless-escape
		let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if( emailRegex.test( props.defaultEmail ) ){
			this.doCheckIfEmailExist( props.defaultEmail );
		}

		this.checkIfEmailExist = debounce( this.checkIfEmailExist, 400 );
	}

	doCheckIfEmailExist = ( email ) => {

		_postCheckIfEmailExist( email )
			.then( res => {
				this.setState({
					valid: true
				});
			})
			.catch( e => {
				this.setState({
					valid: false
				});
			});

	}

	doRegisterUser = () => {

		_postRegisterGhostUser( this.state.email )
			.then( res => {
				this.props.onClose( res.data.user );
			})
			.catch( e =>{
				message.error( e.response.data.err.msg );
			})

	}

	onChangeEmail = ( e ) => {
		
		this.setState({
			email: e.target.value,
			valid: false
		});

		// eslint-disable-next-line no-useless-escape
		let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if( emailRegex.test( e.target.value ) ){
			this.doCheckIfEmailExist( e.target.value );
		}

	}

	

}

export default AddGhostUserDrawer;


// WEBPACK FOOTER //
// ./src/components/user/add-ghost-drawer/index.js